// フォーマット状態タイプ　要共通化。
export enum FormatStatusKinds {
  Available = 0,
  Expired = 1,
  Deleted = 2,
}

export class FormatStatusKindsName {

  static getDisplayName(value: FormatStatusKinds) {
    if (value === FormatStatusKinds.Available) { return ""; }
    if (value === FormatStatusKinds.Expired) { return "期限切れ"; }
    if (value === FormatStatusKinds.Deleted) { return "削除済み"; }

    return "";
  }
}

